/**
 * Support Center 前台交互。
 *
 * 本期只有两件事,其余都交给原生能力:
 *  - 车型轮播:Swiper(全站已在 theme.liquid 引入),配置写法对齐 x-collection-product。
 *  - 搜索入口:表单本身用 GET 提交,禁用 JS 也能跳到搜索结果页;这里只做入口侧的输入清洗。
 *
 * 分类手风琴:互斥由 <details name> 原生实现,JS 只为旧 Safari 兜底。
 */
document.addEventListener('DOMContentLoaded', () => {
  // 单个模块抛错不应该带崩其他模块（与 x-product.js 的 safeInit 同一思路）
  const safeInit = (fn) => {
    try {
      fn();
    } catch (error) {
      console.error(`[x-support] ${fn.name} failed:`, error);
    }
  };

  // 车型轮播。配置写法对齐 x-collection-product / x-slider：
  // 移动端 freeMode 自由滑动不出按钮，桌面端按钮翻页。
  // 两端禁用态由 Swiper 自己往按钮上挂 .swiper-button-disabled，样式见 x-support-models.css。
  function initModelCarousel() {
    const $carousel = document.querySelector('.x-support-models__carousel');
    if (!$carousel) return;

    // 首尾留白交给 slidesOffsetBefore/After，而不是给轨道加 padding ——
    // padding 会和 Swiper 的位移计算打架（自研滚动版本就是栽在这上面）。
    // 与标题的左边距保持一致（见 x-support-models.css 的 __head）：移动 6 / 桌面 40
    const EDGE_OFFSET = xUtils.isMobile() ? 6 : 40;
    const swiperConfig = xUtils.isMobile()
      ? {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 8,
          slidesOffsetBefore: EDGE_OFFSET,
          slidesOffsetAfter: EDGE_OFFSET,
          freeMode: true,
          mousewheel: {
            enabled: true,
            sensitivity: 1,
            releaseOnEdges: false,
            forceToAxis: true,
          },
        }
      : {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesPerGroup: 1,
          slidesOffsetBefore: EDGE_OFFSET,
          slidesOffsetAfter: EDGE_OFFSET,
          loop: false,
          autoplay: false,
          grabCursor: true,
          navigation: {
            prevEl: '.x-support-models__nav .swiper-button-prev',
            nextEl: '.x-support-models__nav .swiper-button-next',
          },
        };

    return new Swiper($carousel, swiperConfig);
  }

  // 分类手风琴的互斥由 <details name="..."> 原生实现（Baseline 2025-09）。
  // 这里只为不支持该属性的旧浏览器（Safari < 17.2）兜底，支持的浏览器直接返回、不挂监听，
  // 免得和原生行为叠加成「开了又被关掉」。
  function initTopicsAccordion() {
    const supportsExclusive = 'name' in document.createElement('details');
    if (supportsExclusive) return;

    // 首页的分类手风琴 + 分类页左菜单的一/二级分组，都靠 name 分组互斥，
    // 一并接管（按 name 比对，不同组之间互不影响）。
    const $items = document.querySelectorAll(
      '.x-support-topics__item[name], .x-support-menu__group[name], .x-support-menu__sub[name]'
    );
    if (!$items.length) return;

    $items.forEach(($item) => {
      $item.addEventListener('toggle', () => {
        // 只在「被打开」时去关别人；关闭时不做任何事，否则会互相触发
        if (!$item.open) return;
        const group = $item.getAttribute('name');
        $items.forEach(($other) => {
          if ($other !== $item && $other.getAttribute('name') === group) {
            $other.open = false;
          }
        });
      });
    });
  }

  function initSearchInput() {
    document.querySelectorAll('.x-support-search-form').forEach(($form) => {
      const $input = $form.querySelector('input[name="q"]');
      if (!$input) return;
      $form.addEventListener('submit', (event) => {
        // 入口限制（见文档 6.4）：截断到 100 字符并剥掉控制字符。
        // 真正的转义在搜索结果页渲染时做（一律 textContent，不拼 HTML），这里只是第一道。
        const cleaned = $input.value.replace(/[\x00-\x1F\x7F]/g, '').trim().slice(0, 100);
        if (!cleaned) {
          // 空词不跳转，免得搜索页拿到空 q 还要专门处理一种状态
          event.preventDefault();
          $input.focus();
          return;
        }
        $input.value = cleaned;
      });
    });
  }

  function initSearchResults() {
    const $page = document.getElementById('x-support-search-results');
    if (!$page) return;

    const params = new URLSearchParams(window.location.search);
    const legacyParams = ['category', 'category_label', 'return_to'];
    if (legacyParams.some((name) => params.has(name))) {
      legacyParams.forEach((name) => params.delete(name));
      try {
        const search = params.toString();
        const cleanUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
        window.history.replaceState(window.history.state, '', cleanUrl);
      } catch (_error) {
        // URL cleanup is cosmetic; global requests must remain global if history update is unavailable.
      }
    }
    const clean = (value) => value.replace(/[\x00-\x1F\x7F]/g, '').trim().slice(0, 100);
    const query = clean(params.get('q') || '');
    const $title = $page.querySelector('[data-search-title]');
    const $status = $page.querySelector('[data-search-status]');
    const $list = $page.querySelector('[data-search-results]');
    const $more = $page.querySelector('[data-search-more]');
    const $error = $page.querySelector('[data-search-error]');
    const $errorMessage = $page.querySelector('[data-search-error-message]');
    const $retry = $page.querySelector('[data-search-retry]');
    const $form = $page.querySelector('form');
    const getData = (name) => $page.dataset[name] || '';

    if ($form) {
      $form.querySelector('[name="q"]').value = query;
    }

    const setTitle = (count) => {
      $title.hidden = count > 0;
      $title.textContent = $title.hidden
        ? ''
        : getData(count === null && query ? 'loading' : 'titleEmpty');
    };
    const appendHighlighted = (parent, text, ranges) => {
      let cursor = 0;
      (Array.isArray(ranges) ? ranges : []).forEach((range) => {
        if (!Array.isArray(range) || range.length < 2) return;
        const start = Math.max(cursor, Math.min(text.length, Number(range[0]) || 0));
        const end = Math.max(start, Math.min(text.length, Number(range[1]) || 0));
        if (start > cursor) parent.appendChild(document.createTextNode(text.slice(cursor, start)));
        if (end > start) {
          const mark = document.createElement('mark');
          mark.textContent = text.slice(start, end);
          parent.appendChild(mark);
          cursor = end;
        }
      });
      if (cursor < text.length) parent.appendChild(document.createTextNode(text.slice(cursor)));
    };
    const validResultUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && /^\/pages\/support\//i.test(url.pathname)
          ? `${url.pathname}${url.search}${url.hash}`
          : null;
      } catch (_error) {
        return null;
      }
    };
    const renderHit = (hit) => {
      const href = validResultUrl(hit.url || '');
      if (!href) return;
      const item = document.createElement('article');
      item.className = 'x-support-search-results__item';
      const link = document.createElement('a');
      link.className = 'x-support-search-results__link';
      link.href = href;
      appendHighlighted(link, String(hit.title || ''), hit.highlights && hit.highlights.title);
      item.appendChild(link);
      const path = Array.isArray(hit.category_path)
        ? hit.category_path.join(' / ')
        : String(hit.category || '');
      if (path) {
        const pathNode = document.createElement('p');
        pathNode.className = 'x-support-search-results__path';
        pathNode.textContent = path;
        item.appendChild(pathNode);
      }
      if (hit.snippet) {
        const snippet = document.createElement('p');
        snippet.className = 'x-support-search-results__snippet';
        appendHighlighted(snippet, String(hit.snippet), hit.highlights && hit.highlights.snippet);
        item.appendChild(snippet);
      }
      $list.appendChild(item);
    };

    let offset = 0;
    let total = 0;
    let loading = false;
    const fetchResults = async () => {
      if (loading || !query) return;
      loading = true;
      $error.hidden = true;
      $more.disabled = true;
      if (!offset) setTitle(null);
      try {
        window.xUtils.showLoading();
        const apiParams = new URLSearchParams({ q: query, locale: 'en', limit: '20', offset: String(offset) });
        const response = await fetch(`${$page.dataset.endpoint}?${apiParams.toString()}`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Search request failed (${response.status})`);
        const data = await response.json();
        if (!Array.isArray(data.hits) || !Number.isFinite(Number(data.total))) throw new Error('Invalid search response');
        total = Number(data.total);
        data.hits.forEach(renderHit);
        offset += data.hits.length;
        setTitle(total);
        $status.textContent = '';
        $more.hidden = offset >= total || !data.hits.length;
        $more.disabled = false;
      } catch (_error) {
        $title.hidden = true;
        $title.textContent = '';
        $errorMessage.textContent = getData('error');
        $error.hidden = false;
        $status.textContent = '';
        $more.hidden = true;
        $more.disabled = false;
      } finally {
        window.xUtils.hideLoading();
        loading = false;
      }
    };

    $more.addEventListener('click', fetchResults);
    $retry.addEventListener('click', fetchResults);
    setTitle(null);
    if (query) fetchResults();
  }

  // 分类页的问题列表 ↔ 详情切换（CSS :target 负责显隐，这里只管滚动位置）。
  //
  // 为什么需要：详情块在文档里排在列表之后，:target 默认会把「那个块」滚进视口，
  // 于是切过去时视窗停在页面中段，看起来像没跳转。scroll-margin-top 只能做偏移量微调，
  // 做不到「回到页面最顶」——所以改由 JS 在 hash 变化后把窗口滚回顶部。
  // 这是纯增强：去掉它内容照常切换，只是落点不好看。
  function initFaqScroll() {
    const $page = document.getElementById('sc-page');
    if (!$page) return;

    const toTop = () => {
      // instant 而不是 smooth：切视图时一段长距离的平滑滚动反而像页面在乱跳
      window.scrollTo({ top: 0, behavior: 'instant' });
    };

    // 在「点击」这一步就接管，而不是等 hashchange —— 这是消除闪烁的关键。
    //
    // 交给浏览器默认行为的话顺序是：写入 hash → 滚到详情块(页面中段) → :target 生效重绘
    // → hashchange → JS 拉回顶部。中间那一帧停在中段，就是看到的「抖一下」。
    //
    // 改成自己接管：阻止默认跳转 → 写 hash（视图切换）→ 立刻把滚动位置纠正到顶。
    // 三件事在同一个事件回调里同步做完，浏览器只在回调结束后绘制一次，
    // 看不到「停在中段」那一帧。CSS 的 scroll-margin-top 还会再兜一层。
    //
    // 必须用 location.replace 而不是 history.replaceState —— 后者「不会」重新计算 :target
    // (这是 HTML 规范定死的行为，不是浏览器 bug)，视图根本切不过去。
    // replace 相对 location.hash = ... 的好处是不往历史栈里压记录：列表↔详情是同一页面的
    // 两个视图，每切一次都留一条记录的话，返回键要按很多下才能离开本页。
    $page.addEventListener('click', (event) => {
      const $link = event.target.closest('a[href^="#"]');
      if (!$link) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if ($link.target && $link.target !== '_self') return;

      const href = $link.getAttribute('href');
      const id = href.slice(1);
      const $target = id ? document.getElementById(id) : null;
      const isFaqDetail = $target?.classList.contains('x-support-category__detail');
      if (id !== 'sc-top' && !isFaqDetail) return;

      event.preventDefault();
      // '#sc-top' 指向列表容器本身，用它回到列表视图：它不是 .x-support-category__detail，
      // 所以没有任何详情块匹配 :target，列表自然显示出来。
      window.location.replace(href);
      // replace 之后浏览器仍会把目标元素滚进视口，所以纠正放在它「之后」。
      // 此时 :target 已生效、DOM 也已按新视图重排，这一下只是修正滚动位置，不会再重绘内容。
      toTop();
    });

    // 直接带着 hash 打开时（分享链接），浏览器仍会自动滚到详情块，这里补一次纠正。
    // 用 getElementById 而不是 querySelector('#'+hash)——FAQ 的 handle 可能以数字开头，
    // 那在选择器语法里非法、会直接抛错。
    const hash = window.location.hash.slice(1);
    if (hash && document.getElementById(hash)) {
      // 等浏览器自己的锚点跳转做完再纠正，否则会被它覆盖
      requestAnimationFrame(toTop);
    }
  }

  function initRichtextTables() {
    document.querySelectorAll('.x-support-richtext table').forEach(($table) => {
      if ($table.parentElement?.classList.contains('x-support-richtext__table-scroll')) return;

      const $wrapper = document.createElement('div');
      $wrapper.className = 'x-support-richtext__table-scroll';
      $table.before($wrapper);
      $wrapper.append($table);
    });
  }

  // 左菜单手风琴的「锚定补偿」：切换时让被点击的那一项在视窗里纹丝不动。
  //
  // 问题：菜单是互斥的，展开一项必然收起另一项。若被收起的那项排在被点击项之前、
  // 且比较高（比如 Bike Models 展开时有 600px），收起后下方内容整体上移同样的距离，
  // 被点击的项就跑到视窗外了，看起来像页面跳了一下。
  //
  // 做法：点击前记下该项相对视窗的位置，<details> 开合完成后再量一次，
  // 把差值补进 scrollY。两次测量之间没有绘制（toggle 是同步的），所以不会闪。
  //
  // 只在移动端做：桌面端菜单在侧栏、滚动幅度小，问题不明显（用户已确认不需要）。
  function initMenuAnchor() {
    const $menu = document.querySelector('.x-support-menu');
    if (!$menu) return;

    const mobileQuery = window.matchMedia('(max-width: 768px)');

    $menu.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;

      // 只认分组头（summary），点链接是跳转、不涉及开合
      const $head = event.target.closest(
        '.x-support-menu__group-head, .x-support-menu__sub-head'
      );
      if (!$head) return;

      let last = $head.getBoundingClientRect().top;

      // 开合带 0.3s 的高度过渡（见 css 的 ::details-content），所以位移不是一次到位、
      // 而是逐帧发生的。只在 rAF 里补一次只能补到第一帧那点量，得跟着过渡一起补。
      //
      // 每帧量一次、补一次差值；连续几帧都没有位移就停 —— 既覆盖了过渡结束，
      // 也兼容不支持高度过渡的浏览器（那里一帧就到位，随即静止、很快退出）。
      const DURATION = 400; // 略大于过渡时长，兜住收尾的抖动
      const start = performance.now();
      let idle = 0;

      const follow = (now) => {
        const top = $head.getBoundingClientRect().top;
        const shift = top - last;

        if (Math.abs(shift) >= 1) {
          idle = 0;
          // 补偿多是「向上滚」，而 x-base.js 的导航显隐正是靠「向上滚就显示」判断的。
          // 不打招呼的话每切一次手风琴就把隐藏的导航拽出来，页面跟着跳一下。
          // 置位让它跳过这些滚动，整个过程结束后再清掉。
          window.X_SUPPRESS_HEADER_SCROLL = true;
          window.scrollBy({ top: shift, behavior: 'instant' });
          last = $head.getBoundingClientRect().top;
        } else {
          idle += 1;
        }

        // 连续 3 帧不动、或超过兜底时长就收工
        if (idle < 3 && now - start < DURATION) {
          requestAnimationFrame(follow);
          return;
        }
        // scroll 事件是异步派发的，不能同步清标志，要等这一轮事件跑完
        setTimeout(() => {
          window.X_SUPPRESS_HEADER_SCROLL = false;
        }, 0);
      };

      requestAnimationFrame(follow);
    });
  }

  safeInit(initModelCarousel);
  safeInit(initTopicsAccordion);
  safeInit(initMenuAnchor);
  safeInit(initFaqScroll);
  safeInit(initRichtextTables);
  safeInit(initSearchInput);
  safeInit(initSearchResults);
});
